import { render, staticRenderFns } from "./HighlightedServices.vue?vue&type=template&id=7518438d&scoped=true&"
import script from "./HighlightedServices.vue?vue&type=script&lang=js&"
export * from "./HighlightedServices.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedServices.vue?vue&type=style&index=0&id=7518438d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7518438d",
  null
  
)

export default component.exports